import React from 'react'
import cssModules from 'react-css-modules'
import { PropTypes } from 'prop-types'

import { ArrowRightIcon, Divider, BodyText, Link } from '@paypalcorp/pp-react'

import styles from './ppgf_inset.less'

import { getI18n } from 'client/i18n'

const i18n = getI18n('components/crowdfunding_charity_detail_view')

class PpgfInset extends React.Component {
  static propTypes = {
    countryCode: PropTypes.string,
    invokeGivingFundTermsModal: PropTypes.function,
    isPreview: PropTypes.bool,
    cdnHost: PropTypes.string,
  }
  constructor(props) {
    super(props)
  }

  render() {
    const { cdnHost } = this.props
    return (
      <React.Fragment>
        <div styleName="ppgf-all-items-container">
          <article styleName="ppgf-flex-container">
            <section styleName="ppgf-step-detail">
              <img
                src={`https://${cdnHost}/webstatic/ppgf/donationtracker/step1.svg`}
                alt="charity step 1"
              />
            </section>

            <section styleName="ppgf-right-arrow-container">
              <ArrowRightIcon />
            </section>

            <section styleName="ppgf-step-detail">
              <img
                src={`https://${cdnHost}/webstatic/ppgf/donationtracker/step2.svg`}
                alt="charity step 2"
              />
            </section>

            <section styleName="ppgf-right-arrow-container">
              <ArrowRightIcon />
            </section>

            <section styleName="ppgf-step-detail">
              <img
                src={`https://${cdnHost}/webstatic/ppgf/donationtracker/step3.svg`}
                alt="charity step 3"
              />
            </section>
          </article>

          <article>
            <BodyText strong="true">{i18n('charity_supporting_to')}</BodyText>
            <Divider />
            <BodyText styleName="margin-bottom-12">
              {i18n(`charity_donating_to_${this.props.countryCode}`)}
            </BodyText>

            <Link
              data-nemo="moreAboutCharity"
              href="javascript:;"
              onClick={
                !this.props.isPreview
                  ? this.props.invokeGivingFundTermsModal
                  : null
              }
            >
              {i18n('giving_fund_more_details_link')}
            </Link>
          </article>
        </div>
      </React.Fragment>
    )
  }
}

export default cssModules(PpgfInset, styles, { allowMultiple: true })
